module.exports = __webpack_public_path__ + "static/media/usn-thumbnail.51d38d59.jpg";